import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { connect } from "react-redux";
import Token from "api/Auth/auth";
import { setMgToken, setHcToken } from "store/Auth";
import store from "store.js";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import bookmark from "../img/bookmark.svg";
import TrendingJobs3 from "../img/trending3.png";
import TrendingJobs2 from "../img/trending2.png";
import TrendingJobs4 from "../img/trending4.png";
import TrendingJobs1 from "../img/trending1.png";
// install Swiper modules
import pin from "../img/pin.svg";
SwiperCore.use([Pagination, Navigation]);

export default function App() {
  return (
    <>
      <div className="flex justify-between items-center mt-16 mb-8">
        <h2 className="fsize28 sm-fsize16 font-bold">
          Explore more career opportunities
        </h2>
        <div className="flex ">
          <ChevronLeft
            width="30px"
            height="30px"
            className="trend-left-i mr-2 disabled"
          />
          <ChevronRight width="30px" height="30px" className="trend-right-i" />
        </div>
      </div>
      <Swiper
        breakpoints={{
          1366: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          420: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          375: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
        }}
        spaceBetween={30}
        slidesPerGroup={4}
        loop={true}
        loopFillGroupWithBlank={true}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        className="mySwiper swiperpagination-dot"
      >
        
      </Swiper>
    </>
  );
}
